import "../../../design/pricing.css";
import { Container } from "react-bootstrap";
import { useEffect, useRef } from "react";
import { WEBSITE_URL } from "../../../api/API_SERVERS";
import { motion } from "framer-motion";
import { FaPaypal, FaInfoCircle, FaExclamationTriangle, FaBell } from "react-icons/fa";

export default function Pricing() {
    const bubbleRef = useRef(null);

    const goRegister = () => {
        window.location.href = `${WEBSITE_URL}/register`;
    };

    useEffect(() => {
        const container = bubbleRef.current;
        const bubbles = [];
        const bubbleCount = window.innerWidth < 768 ? 8 : 15;

        for (let i = 0; i < bubbleCount; i++) {
            const bubble = document.createElement("div");
            bubble.className = "bubble";
            const size = Math.random() * 40 + 20;
            const obj = {
                el: bubble,
                x: Math.random() * window.innerWidth,
                y: Math.random() * window.innerHeight,
                speedY: Math.random() * 0.5 + 0.5,
                speedX: (Math.random() - 0.5) * 0.2
            };
            bubble.style.width = size + "px";
            bubble.style.height = size + "px";
            container.appendChild(bubble);
            bubbles.push(obj);
        }

        let animationId;
        const animate = () => {
            bubbles.forEach(b => {
                b.y -= b.speedY;
                b.x += b.speedX;
                if (b.y < -100) {
                    b.y = window.innerHeight + 50;
                    b.x = Math.random() * window.innerWidth;
                }
                b.el.style.transform = `translate(${b.x}px, ${b.y}px)`;
            });
            animationId = requestAnimationFrame(animate);
        };
        animate();
        return () => cancelAnimationFrame(animationId);
    }, []);

    return (
        <section id={'pricing'} className="pricingSection">
            <div ref={bubbleRef} className="bubbleContainer"></div>

            <Container>
                <div className={'pricingHeader'}>
                    <motion.div
                        initial={{ opacity: 0, y: -20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        className="headerBadge"
                    >
                        მასწავლებლებისთვის
                    </motion.div>
                    <h2>შეარჩიე შენი პაკეტი 🎨</h2>
                    <p>გახდი ჩვენი გუნდის წევრი და გაუზიარე ცოდნა სხვებს</p>
                </div>

                <div className="plansContainer">
                    <motion.div
                        whileHover={{ y: -15 }}
                        className="pricePlan"
                    >
                        <h3>თვიური</h3>
                        <div className="price">
                            15<span className="currency">₾</span>
                            <span className="period">/თვე</span>
                        </div>
                        <ul className="planFeatures">
                        </ul>
                        <button className="planBtn" onClick={goRegister}>დაწყება</button>
                    </motion.div>

                    <motion.div
                        whileHover={{ y: -15 }}
                        className="pricePlan popularPlan"
                    >
                        <div className="popularBadge">საუკეთესო არჩევანი ✨</div>
                        <h3>წლიური</h3>
                        <div className="price">
                            110<span className="currency">₾</span>
                            <span className="period">/წელი</span>
                        </div>
                        <ul className="planFeatures">
                        </ul>
                        <button className="planBtn" onClick={goRegister}>დაწყება</button>
                    </motion.div>
                </div>

                <div className="pricingAlerts">
                    <div className="infoCard alarm">
                        <FaBell className="icon" />
                        <p>ავტომატურ ჩამოჭრას არ ვახორციელებთ.</p>
                    </div>
                    <div className="infoCard warning">
                        <FaExclamationTriangle className="icon" />
                        <p>გამოჩნდებით საიტზე არჩეული ვადით (1 თვე/წელი).</p>
                    </div>
                    <div className="infoCard info">
                        <FaInfoCircle className="icon" />
                        <p>განახლების შეტყობინება დაგხვდებათ ავტორიზაციისას.</p>
                    </div>
                    <div className="infoCard success">
                        <FaPaypal className="icon" />
                        <p>გადახდა: PayPal (ბარათით ან ანგარიშით).</p>
                    </div>
                </div>
            </Container>
        </section>
    );
}